import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SearchUtils from 'search-utils';
import Button from 'button-component';
import GooglePlacesSearchInput from 'search/components/common/GooglePlacesSearchInput';
import {setNewData} from '../../common/search-actions';

class SearchContainer extends Component {
    constructor(props) {
        super(props);

        this._onSuggestionSelect = this._onSuggestionSelect.bind(this);
        this._onSearchClick = this._onSearchClick.bind(this);
    }

    componentDidMount() {
        this._container.style.backgroundColor = `#${this.props.backgroundColor}`;
    }

    _onSuggestionSelect({label, location, placeId, placesPlaceId, reference}) {
        this.props.setNewSearchData({
            data: {
                currentPage: 'map'
            },
            params: {
                search_string: label,
                latitude: location.lat,
                longitude: location.lng,
                places_id: placeId,
                places_place_id: placesPlaceId,
                places_reference: reference
            }
        });
    }

    _onSearchClick() {
        const {
            onMultiOrNoResultsFound,
            setNewSearchData
        } = this.props;
        const value = this._googleSearch.refs.autosuggest.state.value;

        if (!isEmpty(value)) {
            SearchUtils.geocode(value, results => {
                if (isArray(results)) {
                    // no results or more than one result found, show dialog
                    onMultiOrNoResultsFound(results);
                } else {
                    // single result found, set the new address in the store and go to map page
                    setNewSearchData({
                        data: {
                            currentPage: 'map'
                        },
                        params: omit(results, ['city', 'state', 'zipCode'])
                    });
                }
            });
        }
    }

    render() {
        const {
            unbranded,
            isMonthly,
            onLogoClick
        } = this.props;
        let placeholder = 'Search Address';

        if (!isMonthly) {
            placeholder += ' or Event';
        }

        return (
            <div className="SH-SearchContainer" ref={node => { this._container = node; }}>
                {!unbranded &&
                    <Button
                        className="SH-SearchContainer-logo"
                        icon="spothero"
                        onClick={onLogoClick}
                    />
                }
                <div className="SH-SearchContainer-wrapper">
                    <GooglePlacesSearchInput
                        ref={node => { this._googleSearch = node; }}
                        placeholder={placeholder}
                        size="lg"
                        onSuggestionSelect={this._onSuggestionSelect}
                    />
                    <Button
                        color="primary"
                        size="lg"
                        block
                        onClick={this._onSearchClick}
                    >
                        Search
                    </Button>
                </div>
            </div>
        );
    }
}

SearchContainer.propTypes = {
    backgroundColor: PropTypes.string,
    isMonthly: PropTypes.bool,
    unbranded: PropTypes.bool,
    onLogoClick: PropTypes.func.isRequired,
    onMultiOrNoResultsFound: PropTypes.func.isRequired,
    setNewSearchData: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    const {
        search: {
            data: {
                params: {
                    monthly
                }
            }
        }
    } = state;

    return {
        isMonthly: monthly
    };
};

const mapDispatchToProps = {
    setNewSearchData: setNewData
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);



// WEBPACK FOOTER //
// ./widget/src/js/components/search/SearchContainer.jsx